export default __webpack_public_path__ + "static/media/i147vp.a7cb52a5.webp";